<div class="flex flex-col">
	<label class="cursor-pointer" [htmlFor]="key"
		>{{ title }}
		<span
			*ngIf="formGroup.get(key) | controlRequired"
			[ngClass]="{ 'text-warn-600': formGroup.get(key)!.invalid }"
			>*</span
		>
	</label>
	<div class="">
		<ng-container [formGroup]="formGroup" *ngIf="!scope.loading(); else loading">
			<p-toggle-switch
				[disabled]="disabled"
				[readonly]="readonly"
				[trueValue]="trueValue"
				[falseValue]="falseValue"
				[styleClass]="styleClass"
				(onChange)="onChangeCallback($event)"
				[formControlName]="key"
				[(ngModel)]="value"></p-toggle-switch>
		</ng-container>
		<ng-template #loading>
			<div>
				<span class="p-input-icon-right">
					<i class="pi pi-spin pi-spinner"></i>
					<input class="w-5" [name]="key" [id]="key" pInputText disabled />
				</span>
			</div>
		</ng-template>
	</div>
</div>
